/* Display-only context for product detail tag links; never changes search/filter values. */
(function (root) {
  'use strict';
  function carry(nextQuery, currentQuery) {
    const next = new URLSearchParams(nextQuery), current = new URLSearchParams(currentQuery);
    const label = current.get('be_tag');
    const conditions = [...current].filter(([key]) => key === 'q' || key.startsWith('filter.'));
    // Keep the title for sorting/additional filters, but stop labeling a broader result as this tag.
    if (label && conditions.length && conditions.every(([key,value]) => next.getAll(key).includes(value))) {
      next.set('be_tag', label);
    } else next.delete('be_tag');
    return next;
  }
  let originalTitle, lastTitle, initialCollectionLabel;
  function keyword(params) {
    return params.get('be_tag') || params.get('q') || '';
  }
  function countText(params, count) {
    return `${count}アイテム`;
  }
  function collectionTitle(heading, label) {
    label = String(label).trim();
    if ((['all', 'be-nav-multi-use'].includes(heading.dataset.beCollectionHandle) && ['マルチユース', 'その他'].includes(label)) || /^すべての.+製品$/.test(label) || ['売れ筋ランキング','新着商品','ブランド・メーカーから探す','カテゴリから探す','すべての商品','全ての商品'].includes(label)) {
      heading.textContent = label;
      return;
    }
    const term = document.createElement('span');
    term.className = 'be-search-title__term';
    term.textContent = `「${String(label).trim().replace(/の商品$/, '')}」`;
    const suffix = document.createElement('span');
    suffix.className = 'be-search-title__suffix';
    suffix.textContent = 'の商品';
    heading.classList.add('be-search-title');
    heading.replaceChildren(term, suffix);
  }
  function apply(params) {
    const heading = document.querySelector('.collection-hero__title .title-jp');
    if (!heading) return false;
    const label = params.get('be_tag');
    const isSearch = heading.hasAttribute('data-be-search-heading');
    const count = document.querySelector('[data-be-tag-result-count]');
    if (count) {
      count.hidden = false;
      count.textContent = countText(params, count.dataset.beTagResultCount);
    }
    // Dedicated page titles must survive filters, sorting and history navigation.
    if (heading.dataset.beFixedTitle) {
      heading.textContent = heading.dataset.beFixedTitle;
      return false;
    }
    if (!isSearch && heading.hasAttribute('data-be-collection-heading')) {
      if (initialCollectionLabel === undefined) {
        const selected = document.querySelector('#ProductGridContainer [data-be-collection-title]');
        initialCollectionLabel = selected?.dataset.beCollectionTitle || heading.textContent.trim();
        if (heading.dataset.beCollectionHandle === 'all') {
          initialCollectionLabel = 'すべての商品';
          const labels = document.querySelector('[data-be-initial-filter-labels]')?.content;
          for (const [key, value] of params) {
            if (!key.startsWith('filter.') || !value) continue;
            const match = labels && [...labels.querySelectorAll('[data-param]')].find(item => item.dataset.param === key && item.dataset.value === value);
            if (match) { initialCollectionLabel = match.dataset.label; break; }
          }
        }
      }
      const saved = history.state?.beCollectionHeading;
      const displayLabel = saved || initialCollectionLabel;
      collectionTitle(heading, displayLabel);
      if (!saved) history.replaceState({...history.state, beCollectionHeading: displayLabel}, '', location.href);
      if (originalTitle === undefined) originalTitle = document.title;
      const shopSuffix = originalTitle.includes(' – ') ? originalTitle.slice(originalTitle.indexOf(' – ')) : '';
      document.title = displayLabel + shopSuffix;
      return false;
    }
    if (!label && !isSearch) {

      if (lastTitle && document.title === lastTitle) document.title = originalTitle;
      lastTitle = null;
      return false;
    }
    if (originalTitle === undefined) originalTitle = document.title;
    const term = document.createElement('span');
    term.className = 'be-search-title__term';
    term.textContent = `「${keyword(params)}」`;
    const suffix = document.createElement('span');
    suffix.className = 'be-search-title__suffix';
    suffix.textContent = isSearch ? 'の検索結果' : 'の商品';
    heading.classList.add('be-search-title');
    heading.replaceChildren(term, suffix);
    lastTitle = `${term.textContent}${suffix.textContent}`;
    document.title = lastTitle;
    return true;
  }
  const api = {carry, apply, keyword, countText, collectionTitle};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.BeTagSearchTitle = api;
  if (typeof document !== 'undefined') {
    const init = () => {
      const update = () => apply(new URLSearchParams(location.search));
      update();
      const grid = document.getElementById('ProductGridContainer');
      if (grid && document.querySelector('[data-be-collection-heading]')) new MutationObserver(update).observe(grid, {childList:true});
    };
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
    root.addEventListener('popstate', () => apply(new URLSearchParams(location.search)));
  }
})(typeof window === 'undefined' ? globalThis : window);
